import React, {Component} from 'react';

import './Cookie.css';

class Cookie extends Component {

    onClickCookieAgreed(e) {
        e.preventDefault();
        localStorage.setItem('cookieAgreed', true);
        this.props.cookieAccepted();
    }

    render() {
        return (
            <div className="container-fluid cookie-consent">
                <div className="row py-2">
                    <div className="col-sm-12 col-md-10">
                        <p className="px-5 py-3 text-white">
                            To help personalize content, tailor and measure ads, and provide a safer experience, we use
                            cookies.
                            By clicking or navigating the site, you agree to allow our collection of information on and
                            off
                            euBines through cookies.
                        </p>
                    </div>
                    <div className="col-sm-12 col-md-2 d-flex justify-content-center">
                        <a className="text-white px-5 px-sm-2 py-3"
                           onClick={e => this.onClickCookieAgreed(e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path fill="currentColor"
                                      d="M10.36 11.123l-8.6 8.6-.982-.984 8.6-8.6-8.6-8.6.983-.983 8.6 8.6 8.6-8.6.983.983-8.6 8.6 8.6 8.6-.983.984z"/>
                            </svg>
                        </a>
                    </div>
                    {/*<div className="col-sm-12 col-lg-2 col-md-4 ">*/}
                    {/*    <a className="text-white px-5 py-5"*/}
                    {/*       onClick={e => this.onClickCookieAgreed(e)}>*/}
                    {/*        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">*/}
                    {/*            <path fill="currentColor"*/}
                    {/*                  d="M10.36 11.123l-8.6 8.6-.982-.984 8.6-8.6-8.6-8.6.983-.983 8.6 8.6 8.6-8.6.983.983-8.6 8.6 8.6 8.6-.983.984z"/>*/}
                    {/*        </svg>*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    }

}

export default Cookie;



// WEBPACK FOOTER //
// ./src/components/Cookie/Cookie.js